module.exports = __webpack_public_path__ + "loading.svg?ac52e02a0fdcab5311fff0c9cc5aedd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.svg
// module id = 135
// module chunks = 0